$ = require('jquery')
matchHeight = require('./matchHeight')
scrollbar = require('./scrollbar')

module.exports =
	init: (payload) ->
		{$target} = payload

		parcelshop = ($this) ->
			$closest = $this.closest('.parcelshop')
			$box = $closest.find('.parcelshop__box')
			$btn = $closest.find('.parcelshop__btn')

			$.ajax(
				url: $closest.data('url')
				beforeSend: ->
					$btn.addClass('is-loading')
			)
			.done( (response) ->
				$box.html(response)
				$btn.removeClass('is-loading')
			)


		$(document)
			# open review form
			.on('click', '.btn-add-review', (event) ->
				event.preventDefault()
				$('.f-review').addClass('is-active')
				$('.b-rating').addClass('is-hidden')
			)
			# close review form
			.on('click', '.f-review__close', (event) ->
				event.preventDefault()
				$('.f-review').removeClass('is-active')
				$('.b-rating').removeClass('is-hidden')
			)
			# open right sidebar add to compare
			.on('click', '.btn--add-compare', (event) ->
				event.preventDefault()

				$this = $(@)
				$box = $('.b-sidebar--compare')

				$this.addClass('is-loading')
				$('.b-sidebar').removeClass('is-active')

				$.ajax(
					url: $this.attr('href')
				)
				.done( (response) ->
					$this.removeClass('is-loading')
					$box.addClass('is-active')
					$box.html( response )
				)
			)
			# open right sidebar add to cart
			# .on('click', '.btn--add-basket', (event) ->
			# 	event.preventDefault()

			# 	$this = $(@)
			# 	$box = $('.b-sidebar--basket')
			# 	$basket = $('.b-basket')
			# 	$basketTable = $('.b-basket-table')
			# 	$accessories = $('.c-accessories').closest('.b-default')

			# 	$this.addClass('is-loading')
			# 	$('.b-sidebar').removeClass('is-active')

			# 	$.ajax(
			# 		url: $this.attr('href')
			# 	)
			# 	.done( (response) ->
			# 		$this.removeClass('is-loading')
			# 		$basket.html( response.basket )

			# 		if $basketTable.length
			# 			$basketTable.html( response.table )
			# 			$('body, html').animate(
			# 				scrollTop: $basketTable.offset().top
			# 			250)

			# 			if response.accessories
			# 				$accessories.find('.c-accessories').html( $(response.accessories).find('.c-accessories').html() )
			# 			else
			# 				$accessories.remove()

			# 			matchHeight.init({$target:$accessories})
			# 			scrollbar.init({$target:$accessories})
			# 		else
			# 			$box.addClass('is-active')
			# 			$box.html( response.side )
			# 	)
			# )
			.on('submit', '.f-buy', (event) ->
				event.preventDefault()

				$this = $(@)
				$btn = $this.find('button')
				$box = $('.b-sidebar--basket')
				$basket = $('.b-basket')
				$basketTable = $('.b-basket-table')
				$accessories = $('.c-accessories').closest('.b-default')

				$btn.addClass('is-loading')
				$('.b-sidebar').removeClass('is-active')

				$.ajax(
					url: $this.attr('action')
					data: $this.serialize()
				)
				.done( (response) ->
					$btn.removeClass('is-loading')
					$basket.html( response.basket )

					if $basketTable.length
						$basketTable.html( response.table )
						$('body, html').animate(
							scrollTop: $basketTable.offset().top
						250)

						if response.accessories
							$accessories.find('.c-accessories').html( $(response.accessories).find('.c-accessories').html() )
						else
							$accessories.remove()

						matchHeight.init({$target:$accessories})
						scrollbar.init({$target:$accessories})
					else
						$box.addClass('is-active')
						$box.html( response.side )
				)

				return false;
			)
			# close right sidebar
			.on('click', '.b-sidebar__close', (event) ->
				event.preventDefault()

				$('.b-sidebar').removeClass('is-active')
			)
			.on('click', (event) ->
				if not $(event.target).closest('.b-sidebar').length
					$('.b-sidebar.is-active').removeClass('is-active')
			)
			# remove from compare
			.on('click', '.b-basket-side__remove', (event) ->
				event.preventDefault()

				$t = $(this).parent()
				$t.animate(
					opacity: 0
				, 500, ->
					$t.slideUp(->
						$t.remove()
						# close sidebar if compare list is empty
						if ($('.b-sidebar--compare .b-basket-side__list li').length == 0)
							$('.b-sidebar').removeClass('is-active')
					)
				)
			)
			# parcelshop
			.on('click', '.parcelshop__btn', (event) ->
				event.preventDefault()

				parcelshop($(this))
			)
			.on('keydown', '.parcelshop__inp, .parcelshop__btn', (event) ->
				if event.keyCode == 13
					parcelshop($(this))
					return false
			)




// WEBPACK FOOTER //
// ./src/js/components/forms.coffee